import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class ExchangeRateService {
    private corsAnywhereUrl = 'https://cors-anywhere.herokuapp.com/'
    private apiUrl = 'https://api.apilayer.com/fixer/latest'
    private accessKey = 'ToImPjphYDhe90dRCBSbH9ALWH7LDFFY'

    constructor(private http: HttpClient) { }

    getExchangeRate(baseCurrency: string, targetCurrency: string): Observable<any> {
        const url = `${this.corsAnywhereUrl}${this.apiUrl}?access_key=${this.accessKey}&base=${baseCurrency}&symbols=${targetCurrency}`
        const headers = new HttpHeaders({
            'Origin': 'http://localhost:4200',
            'apiKey': 'ToImPjphYDhe90dRCBSbH9ALWH7LDFFY'
        })

        return this.http.get(url, { headers })
    }
}